/**
 *
 * ResultDimensionTable
 *
 */

import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import ResultByDimension from "../../../../components/ResultByDimension"
import ResultByDimensionV2 from "../../../../components/ResultByDimensionV2"
import "./index.less"

const recursiveFindChildsId = (array = [], data) => {
  array.push(data.id_dimension)
  if (data.childs && data.childs.length > 0) {
    data.childs.map((e) => recursiveFindChildsId(array, e))
  }
  return array
}
export class ResultDimensionTable extends React.Component {
  state = { openDimensions: [] }

  clickDimension = (item) => {
    const { openDimensions } = this.state
    const index = openDimensions.findIndex((e) => e === item.id_dimension)
    if (index > -1) {
      openDimensions.splice(index, 1)
      const indexChilds = recursiveFindChildsId([], item)
      indexChilds.map((iC) => {
        const indexChild = openDimensions.findIndex((e) => e === iC)
        if (indexChild > -1) {
          openDimensions.splice(indexChild, 1)
        }
      })
    } else {
      openDimensions.push(item.id_dimension)
    }
    this.setState({ openDimensions })
  }

  render() {
    const { openDimensions } = this.state
    const {
      data,
      isLoading,
      bubble,
      showVariation,
      divisions,
      selectedDivision,
      meditions = [],
      measureColorRange,
      metricsTotalLabel,
      showBenchmark,
      measureGeneral,
      measureInfo,
      ifFirst,
    } = this.props

    return (
      <ResultByDimensionV2
        divisions={divisions}
        showDimensionBenchmark={showBenchmark}
        measureInfo={measureInfo}
        measureColorRange={measureColorRange}
        showHistory={showVariation}
        showVariation={showVariation}
        ifFirst={ifFirst}
        bubble={bubble}
        showBenchmark={showBenchmark}
        isExpandable
        data={this.props.data}
      />
    )
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(ResultDimensionTable)
